// extracted by mini-css-extract-plugin
export default {"heightSm":"styles_heightSm__x120F","heightLg":"styles_heightLg__mtYaL"};